import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import moment from 'moment'
import { BootstrapVue } from './plugins/bootstrap.js'
import { auth } from './firebase'

Vue.config.productionTip = false

// instanc efor Moment
Vue.prototype.moment = moment

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)

let app
auth.onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }

  if (user) {
    store.dispatch('fetchUserProfile', user)
  }

})
